module.exports = __webpack_public_path__ + "img/truck-warning.d34054fd.svg";